import styles from "./StatsContainerLp.module.scss";
import cn, { clsx } from "clsx";

interface BannerImageTempleteType {
    ShortDescLabel1?: string;
    ShortDescLabel2?: string;
    ShortDescLabel3?: string;
    ShortDescSubLabel1?: string
    ShortDescSubLabel2?: string
    ShortDescSubLabel3?: string
}
interface StatsContainerProps {
    isStatsDisplay?: boolean;
    BannerImageTemplete?: BannerImageTempleteType;
}
const StatsContainerLp = ({
    isStatsDisplay = false,
    BannerImageTemplete = {}
}: StatsContainerProps) => {
    return (
        <div className={cn(styles.statics_container, { ["!hidden"]: !isStatsDisplay })}>
            <div className={cn(styles.stats)}>
                <span className={clsx(styles.text1, "lining-nums")}>{BannerImageTemplete?.ShortDescLabel1}</span>
                <span className={styles.text2}>{BannerImageTemplete?.ShortDescSubLabel1}</span>
            </div>
            <div className={styles.border_right} />
            <div className={cn(styles.stats)}>
                <span className={clsx(styles.text1, "lining-nums")}>{BannerImageTemplete?.ShortDescLabel2}</span>
                <span className={styles.text2}>{BannerImageTemplete?.ShortDescSubLabel2}</span>
            </div>
            <div className={styles.border_right} />
            <div className={cn(styles.stats)}>
                <span className={clsx(styles.text1, "lining-nums")}>{BannerImageTemplete?.ShortDescLabel3}</span>
                <span className={styles.text2}>{BannerImageTemplete?.ShortDescSubLabel3}</span>
            </div>
        </div>
    )
};

export default StatsContainerLp;